import React from "react";

import "./index.scss";

export type SubtitleProps = React.PropsWithChildren;

export const Subtitle: React.FC<SubtitleProps> = ({ children }) => {
  return <div className="progress-subtitle">{children}</div>;
};
